<message [icon]="icon"
         message="{{message}}"
         [html]="html"
         [showLinkToHelp]="showLinkToHelp"
         [showLinkToContact]="showLinkToContact"
         [showButton]="showButton"
         [showLinkToStart]="showLinkToStart">
></message>
